import { LineStyle } from "../../drawing/LineStyle";

export interface ILineDrawable {
  lineStyle: LineStyle;
}

export function instanceOfILineDrawable(instance: any): instance is ILineDrawable {
  return instance
    && (instance.lineStyle !== undefined);
}
